module.exports = __webpack_public_path__ + "static/media/4304ClarenceOutside.55ffc3f6.jpg";